//Colors DB:-
let color_1  = '#001E3C',
    color_2  = '#071A2F',
    color_3  = '#132F4C',
    color_4  = '#173A5E',
    color_5  = '#0070E0',
    color_6  = '#0059B2',
    color_7  = '#F3F6F9',
    color_8  = '#EAEEF3',
    color_9  = '#fff',
    color_10 = '#46505A',
    color_11 = '#f44336',
    color_12 = "#ccc"

export const lightTheme = {
    body_bg: color_9,

    button_color_1: color_7,
    button_color_2: color_10,
    button_bg_1: color_5,
    button_hover_bg_1: color_6,
    button_bg_2: color_7,
    button_hover_bg_2: color_8,
    button_bg_3: color_10,
    button_border: color_10,

    input_color: color_10,
    input_placeholder: color_10,
    input_bg: color_7,
    input_hover_bg: color_8,
    input_border: color_6,
    input_hover_border: color_5,

    loader_color_1: color_5,
    loader_color_2: color_7,

    error_color: color_11,

    form_bg: color_7,
    form_border: color_10,

    text_color: color_3,

    navbar_bg: color_9,
    navbar_border: color_10, 
    navbar_toggler_bg: color_7,
    navbar_dropdown_item_color: color_3,
    navbar_dropdown_item_hover_color: color_5,

    footer_bg: color_9,
    footer_border: color_10, 

    box_shadow_color: color_3,

    side_text_color: color_12,

    modal_bg: color_7,
    modal_title_border: color_10,

    scrollbar_bg: color_3,

    overlay_bg: color_7
}

export const darkTheme = {
    body_bg: color_1,

    button_color_1: color_7,
    button_color_2: color_7,
    button_bg_1: color_5,
    button_hover_bg_1: color_6,
    button_bg_2: color_3,
    button_hover_bg_2: color_4,
    button_bg_3: color_10,
    button_border: color_7,

    input_color: color_7,
    input_placeholder: color_7,
    input_bg: color_3,
    input_hover_bg: color_4,
    input_border: color_6,
    input_hover_border: color_5,

    loader_color_1: color_5,
    loader_color_2: color_7,

    error_color: color_11,

    form_bg: color_2,
    form_border: color_7,

    text_color: color_7,

    navbar_bg: color_2,
    navbar_border: color_7,
    navbar_toggler_bg: color_7,
    navbar_dropdown_item_color: color_3,
    navbar_dropdown_item_hover_color: color_5,

    footer_bg: color_2,
    footer_border: color_7,

    box_shadow_color: color_7,

    side_text_color: color_12,

    modal_bg: color_4,
    modal_title_border: color_7,
    
    scrollbar_bg: color_7,

    overlay_bg: color_10
}